import { render } from "./CourseLessons.vue?vue&type=template&id=4b615db9"
import script from "./CourseLessons.vue?vue&type=script&lang=js"
export * from "./CourseLessons.vue?vue&type=script&lang=js"

import "./CourseLessons.vue?vue&type=style&index=0&id=4b615db9&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__